export const endpoints = {
  MAINURLUAT: 'https://hcmuat.evonsys.com.au/prweb/api/atsapi/v1/',
  MAINURLDev: 'https://hcmdev.evonsys.com.au/prweb/api/atsapi/v1/',
  MAINURLCLIENT: 'https://client1.peoplehcm.com/prweb/api/atsapi/v1/',
  VALIDATEAPPLICANT: 'ValidateApplicant',
  APPLICANTAVAILABLESLOTS:'ApplicantAvailableSlots'
}
